import React from 'react';
import { Typography } from 'seagull';
import { Attached24, Notes, Service as ServiceIcon } from 'seagull/icons';
import { fromCents } from "../../../components/ServiceCreation/ServiceCreation.utils";
import { getUnitName } from "../../../utils/unit-name.utils";
import { Card } from "./Card";
import styles from "./DeliveryDetails.module.scss";
import { serviceModel } from "../../../models";
import { utils } from "../../../utils";
export function DeliveryDetails(_ref) {
  var _billCommand$price;
  let {
    service,
    billCommand,
    FileButton
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, {
    title: /*#__PURE__*/React.createElement("div", {
      className: styles.serviceTitle
    }, /*#__PURE__*/React.createElement(Typography, null, service.name), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      "data-testid": "sda-price"
    }, utils.formatDollarAmount(utils.calculateFinalPrice(serviceModel.price(service) || fromCents((_billCommand$price = billCommand.price) !== null && _billCommand$price !== void 0 ? _billCommand$price : 0) || 0, service.cost.discount, billCommand.quantity))))
  }, service.cost.pricingType === 'variable' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "sda-review-price",
    className: styles.textWithIcon
  }, /*#__PURE__*/React.createElement(ServiceIcon, null), /*#__PURE__*/React.createElement(Typography, null, "Price")), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    className: styles.listItem
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, "Price per ", getUnitName(service.cost.unitName), ":", ' ', utils.formatDollarAmount(utils.calculateFinalPrice(service.cost.price, service.cost.discount)))), /*#__PURE__*/React.createElement("li", {
    className: styles.listItem
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, "Quantity: ", billCommand.quantity, " ", getUnitName(service.cost.unitName), "(s)")), /*#__PURE__*/React.createElement("li", {
    className: styles.listItem
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, "Total:", ' ', utils.formatDollarAmount(utils.calculateFinalPrice(service.cost.price, service.cost.discount, billCommand.quantity)))))), billCommand.note && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "sda-review-notes",
    className: styles.textWithIcon
  }, /*#__PURE__*/React.createElement(Notes, null), /*#__PURE__*/React.createElement(Typography, null, "Delivery notes")), /*#__PURE__*/React.createElement(Typography, {
    className: styles.notes,
    "data-testid": "sda-vendor-notes",
    skin: "secondary"
  }, billCommand.note)), /*#__PURE__*/React.createElement("div", {
    className: styles.textWithIcon
  }, /*#__PURE__*/React.createElement(Attached24, null), /*#__PURE__*/React.createElement(Typography, null, "Delivery of files")), /*#__PURE__*/React.createElement("ul", null, billCommand.deliverables.files.map(file => /*#__PURE__*/React.createElement("li", {
    key: file.fileId,
    className: styles.listItem
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    className: styles.listContent
  }, file.filename), FileButton && /*#__PURE__*/React.cloneElement(FileButton, {
    file
  })))));
}